import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import {
  RELATED_PARTY_RELATIONSHIP,
  RELATED_PARTY_TYPES,
} from '../../../../../../../constants';

const {
  formField: { principalType, principalOccupation, principalOtherOccupation },
} = loanFormModel;

export class PrincipalOtherOccupationValidation implements ValidationSchema {
  public name = principalOtherOccupation.name;
  public label = principalOtherOccupation.label;
  public dependsOn: string[] = [principalOccupation.name, principalType.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    principalOccupation: string,
    principalType: string,
    schema,
    context
  ) {
    const isPrincipal =
      context.parent.relationship == RELATED_PARTY_RELATIONSHIP.PRINCIPAL;
    if (
      principalOccupation === 'Other' &&
      principalType === RELATED_PARTY_TYPES.INDIVIDUAL &&
      isPrincipal
    ) {
      return schema.required(principalOtherOccupation.requiredErrorMsg);
    }
    return schema.notRequired();
  }
}
export default new Validation(new PrincipalOtherOccupationValidation());
